export const MEDIA_BASE_URL = 'https://globalsound.dma.org';

export const MAX_SOUND_DURATION = 30;

export const ANALYSER_NUM_SPECTRAL_FREQUENCIES = 128;
export const ANALYSER_SMOOTHING = 0.8;